import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { Select } from 'antd';
import {
  Card,
  ScrollView,
  OfferTypeSearch,
  InfoInput,
  InfoCheckBox,
  OfferInfoContainer,
} from "components";
import { INIT_OFFER_TEXT } from "config";
import { useMainContext } from "contexts";

export const OfferInfo = ({
  isEmpty,
  offerTypeData = [],
  useDefaultSaveOfferText = true,
  isLinerDisabled = false
}) => {
  const { currentInfo, isManualEntry, updateInfos } = useMainContext();

  const handleOfferTypeChange = (params) => {
    if (params && isManualEntry) {
      setTimeout(() => {
        updateInfos({
          offer_text: INIT_OFFER_TEXT[params.toLowerCase()],
          offer_type: params,
        });
      }, 300);
    }
  };

  return (
      <div>
      {isEmpty ? (
        <div className="mt-4 pt-4 text-center">No offers available</div>
      ) : (
        <ScrollView>
          <form autoComplete="off">
            <input style={{ display: "none" }} autoComplete="false"></input>
            <OfferInfoContainer inputId="offer_type">
              <OfferTypeSearch
                label="Offer Type"
                inputId="offer_type"
                data={offerTypeData}
                disabled={!isManualEntry}
                onChange={handleOfferTypeChange}
              />
            </OfferInfoContainer>
            <InfoInput
              className="mt-3"
              label="Offer Text"
              inputId="offer_text"
              disabled={
                currentInfo && currentInfo.offer_type?.toLowerCase() === 'w/agreement'
              }
            />
            <div className="d-flex mt-3">
              <InfoInput label="Reg. Price Start" inputId="reg_price" type="float" />
              <InfoInput label="Reg. Price End" inputId="reg_price2_d" type="float" />
              <InfoInput label="Limit" inputId="limit" type="float" />
            </div>
            <div className="mt-2" style={{ display: 'flex', alignItems: 'flex-end', gap: '12px' }}>
              <div style={{ flex: 1 }}>
                <InfoInput
                  inputId="min_qty"
                  type="float"
                  label="Minimum Qualifier"
                />
              </div>
              <Select
                style={{ width: '120px', marginBottom: '1px' }}
                value={currentInfo?.min_qty_dollar_f}
                onChange={(value) => updateInfos({ min_qty_dollar_f: value })}
                options={[
                  { value: true, label: 'Dollars' },
                  { value: false, label: 'Quantity' }
                ]}
              />
            </div>
            <InfoCheckBox
              className="mt-3"
              inputId="must_buy_f"
              label="Does the offer have must buy amounts?"
            />
            <InfoCheckBox
              className="mt-3"
              inputId="mix_and_match_f"
              label="Does the offer allow mix and match?"
            />
            <InfoCheckBox
              className="mt-3"
              inputId="include_in_net_cost_f"
              label="Does the offer include net cost?"
            />
            {!isLinerDisabled &&
              <InfoCheckBox
                className="mt-3"
                inputId="liner_f"
                label="Does the offer have a liner?"
              />
            }
          </form>
        </ScrollView>
      )}
      </div>
  );
};

